/**
 * The "push changes to my account record" choice.
 *
 * In the wizard, existing-account mode only: there is no prior record for a brand-new insured
 * to diverge from. Default ON, so the account keeps up with what the broker just
 * corrected unless they deliberately opt out.
 *
 * Extracted in BRK-S152 because the roster step offers the same choice about the
 * same save — a second copy of this label is a second wording of one promise.
 * Moved out of the wizard in BRK-S182, when the GIA section's email save began
 * offering it too: one component, so the wizard and the GIA say it identically.
 */
export function PushToAccountToggle({
  on,
  onChange,
}: {
  on: boolean;
  onChange: (on: boolean) => void;
}) {
  return (
    <label className="flex items-start gap-3 rounded-lg border border-brk-border bg-brk-panel p-4">
      <input
        type="checkbox"
        className="mt-0.5 h-4 w-4"
        checked={on}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className="flex flex-col gap-0.5">
        <span className="text-sm font-medium text-brk-text">
          Push changes to my account record
        </span>
        <span className="text-sm text-brk-dim">
          Unchecked, these edits stay with this bond order only.
        </span>
      </span>
    </label>
  );
}
